// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersTwoToneSvg from "@ant-design/icons-svg/es/asn/SlidersTwoTone";
import AntdIcon from '../components/AntdIcon';

var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlidersTwoToneSvg
  }));
};

SlidersTwoTone.displayName = 'SlidersTwoTone';
export default React.forwardRef(SlidersTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SlidersTwoTone.js
// module id = 1833
// module chunks = 0